import { Button, Fieldset, Heading } from '@digdir/designsystemet-react';
import { Link } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { EnergiObjektType } from '../../../../../utils/matrikkelBygningsTyper';

import { BeskrivelseInput } from './components/beskrivelseInput';
import { UnderkategoriSelect } from './components/underkategoriSelect';
import { KategoriSelect } from './components/kategoriSelect';
import { TiltakFormData } from './types';
import { ButtonWrapper, FieldGroup, FormContentWrapper, StyledCard } from './components/styledComponents';

interface FormProps {
  onSubmit: (data: TiltakFormData) => void;
  energiobjekttype: EnergiObjektType;
  defaultValues?: TiltakFormData;
}

const emptyFormData: Partial<TiltakFormData> = {
  kategori: undefined,
  underkategori: undefined,
  beskrivelse: '',
  tittel: ''
};

export const TiltakForm: FC<FormProps> = ({ onSubmit, energiobjekttype, defaultValues }) => {
  const { t } = useTranslation('', { keyPrefix: 'screens.energiplan.components.tiltakForm' });
  const methods = useForm<TiltakFormData>({
    defaultValues: defaultValues || emptyFormData
  });

  return (
    <FormProvider {...methods}>
      <form noValidate onSubmit={methods.handleSubmit(onSubmit)}>
        <FormContentWrapper>
          <Heading level={1} data-size="lg">
            {t('index.heading')}
          </Heading>
          <StyledCard>
            <Fieldset>
              <Fieldset.Legend>{t('index.legend')}</Fieldset.Legend>{' '}
              <FieldGroup>
                <KategoriSelect energiobjekttype={energiobjekttype} />
                <UnderkategoriSelect energiobjekttype={energiobjekttype} />
                <BeskrivelseInput />
              </FieldGroup>
            </Fieldset>
          </StyledCard>
          <ButtonWrapper>
            <Button asChild variant="secondary" type="button">
              <Link to="../">{t('index.cancel')}</Link>
            </Button>
            <Button type="submit">{t('index.submit')}</Button>
          </ButtonWrapper>
        </FormContentWrapper>
      </form>
    </FormProvider>
  );
};
